export default "__VITE_ASSET__BoBM6A1F__"